import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { Calculator } from 'lucide-react';
import AcctDashboard from './AcctDashboard';
import Invoices from './Invoices';
import Estimates from './Estimates';
import AcctCustomers from './AcctCustomers';
import Products from './Products';
import Expenses from './Expenses';
import Vendors from './Vendors';
import Bills from './Bills';
import Banking from './Banking';
import ChartOfAccounts from './ChartOfAccounts';
import AcctReports from './AcctReports';
import Statements from './books/Statements';
import Journal from './books/Journal';
import Ledger from './books/Ledger';
import Reconcile from './books/Reconcile';
import Payroll from './books/Payroll';
import FixedAssets from './books/FixedAssets';
import CloseBooks from './books/CloseBooks';

const tabs = [
  { name: 'Dashboard', path: '', icon: 'LayoutDashboard' },
  { name: 'Invoices', path: 'invoices', icon: 'FileText' },
  { name: 'Estimates', path: 'estimates', icon: 'FileSignature' },
  { name: 'Customers', path: 'customers', icon: 'Users' },
  { name: 'Products', path: 'products', icon: 'Package' },
  { name: 'Expenses', path: 'expenses', icon: 'Receipt' },
  { name: 'Vendors', path: 'vendors', icon: 'Truck' },
  { name: 'Bills', path: 'bills', icon: 'FileMinus' },
  { name: 'Banking', path: 'banking', icon: 'Landmark' },
  { name: 'Reconcile', path: 'reconcile', icon: 'ListChecks' },
  { name: 'Payroll', path: 'payroll', icon: 'Wallet' },
  { name: 'Fixed Assets', path: 'assets', icon: 'Car' },
  { name: 'Chart of Accounts', path: 'coa', icon: 'BookOpen' },
  { name: 'Journal', path: 'journal', icon: 'NotebookPen' },
  { name: 'Ledger', path: 'ledger', icon: 'BookText' },
  { name: 'Statements', path: 'statements', icon: 'FileBarChart' },
  { name: 'Reports', path: 'reports', icon: 'BarChart3' },
  { name: 'Close Books', path: 'close', icon: 'Lock' },
];

export default function AccountingApp() {
  return (
    <div className="flex flex-col min-h-[calc(100vh-64px)] bg-slate-50">
      <div className="bg-white border-b border-slate-200 px-6 lg:px-8 pt-5">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#6FA82C] to-[#8BC53F] text-white flex items-center justify-center">
            <Calculator className="w-5 h-5"/>
          </div>
          <div>
            <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">Accounting</h1>
            <p className="text-xs text-slate-500">Full accounting · synced to your account</p>
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto -mb-px">
          {tabs.map(t => {
            const Ico = Icons[t.icon] || Icons.Circle;
            return (
              <NavLink key={t.name} end={t.path === ''} to={t.path ? `/app/accounting/${t.path}` : '/app/accounting'}
                className={({isActive}) => `flex items-center gap-1.5 px-4 py-3 text-sm font-semibold border-b-2 whitespace-nowrap transition ${isActive ? 'border-[#8BC53F] text-[#6FA82C]' : 'border-transparent text-slate-600 hover:text-slate-900'}`}>
                <Ico className="w-4 h-4"/>{t.name}
              </NavLink>
            );
          })}
        </nav>
      </div>
      <div className="flex-1">
        <Routes>
          <Route index element={<AcctDashboard/>}/>
          <Route path="invoices" element={<Invoices/>}/>
          <Route path="estimates" element={<Estimates/>}/>
          <Route path="customers" element={<AcctCustomers/>}/>
          <Route path="products" element={<Products/>}/>
          <Route path="expenses" element={<Expenses/>}/>
          <Route path="vendors" element={<Vendors/>}/>
          <Route path="bills" element={<Bills/>}/>
          <Route path="banking" element={<Banking/>}/>
          <Route path="coa" element={<ChartOfAccounts/>}/>
          <Route path="reports" element={<AcctReports/>}/>
          <Route path="reconcile" element={<Reconcile/>}/>
          <Route path="payroll" element={<Payroll/>}/>
          <Route path="assets" element={<FixedAssets/>}/>
          <Route path="journal" element={<Journal/>}/>
          <Route path="ledger" element={<Ledger/>}/>
          <Route path="statements" element={<Statements/>}/>
          <Route path="close" element={<CloseBooks/>}/>
        </Routes>
      </div>
    </div>
  );
}
